
import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { walletReportsConfig } from "../../config/tableConfigs";

import { useEffect } from "react";

const OtherUserMainWalletReportsPage = () => {
  

  
      const [userid, setUserid] = useState(() => {
        try {
          const params = new URLSearchParams(window.location.search);
          const encoded = params.get("data");
    
          if (!encoded) return null;
    
          const decoded = JSON.parse(
            atob(decodeURIComponent(encoded))
          );
    
          return decoded.userid || null;
        } catch (err) {
          console.error("Decode userid failed:", err);
          return null;
        }
      });
    
      const [role, setRole] = useState(() => {
        try {
          const params = new URLSearchParams(window.location.search);
          const encoded = params.get("data");
    
          if (!encoded) return null;
    
          const decoded = JSON.parse(
            atob(decodeURIComponent(encoded))
          );
          console.log("Decode role failed:", decoded.role);
          return decoded.role || null;
        } catch (err) {
          console.error("Decode role failed:", err);
          return null;
        }
      });
    
    
    // useEffect(() => {
    //   const storedUserId = sessionStorage.getItem("reportUserId");
    //   const storedRole = sessionStorage.getItem("reportUserRole");
  
    //   if (storedUserId) {
    //     setUserid(storedUserId);
    //     setRole(storedRole);
    //   } else {
    //     console.warn("No report user data found in sessionStorage");
    //   }
    // }, []);
    
  const userRole = role;
  // Default API URL (without hardcoded invalid dates)
  const getLast7Days = () => {
    const today = new Date();
  
    const last7 = new Date();
    last7.setDate(today.getDate() - 1);
  
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
  
    return {
      start: last7.toISOString().split("T")[0],
      end: tomorrow.toISOString().split("T")[0],
    };
  };
  
 
  
  
  const { start, end } = getLast7Days();
  
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const apiUrl = useMemo(() => {
    if (!userid) return null;
  
    return `https://pro.mokshiq.in/main_wallet_report?user=${userid}&filter_date=${startDate}&end_date=${endDate}`;
  }, [userid, startDate, endDate]);
  // Example: set this dynamically after login if needed
 
//   if (!userid) return <div>Loading...</div>;

//   const tableData = useTableData(apiUrl, walletReportsConfig);
const tableData = useTableData(
    apiUrl,
    walletReportsConfig
  );

  // Called by PageWrapper when date range changes
  const handleDateFilter = (startDate, endDate) => {
    console.log("Date Filter Applied:", startDate, "→", endDate);
    const newUrl = `https://pro.mokshiq.in/main_wallet_report?user=${userid}&filter_date=${startDate}&end_date=${endDate}`;
    // setApiUrl(newUrl);
  };

  // === Role-based column filtering ===
  const filteredConfig = useMemo(() => {
    const baseConfig = { ...walletReportsConfig };

    const roleColumnMap = {
      "Retailer": [
        "id",
  "order_id",
  "product",
  "amount",
  "status",
  "type",
  "opening_balance",
  "closing_balance",
  "commission",
  "tds",
  "charge",
  "created_at",
  "txn_id",
  "Transection Flow"
      ],
      "Distributer": [
        "id",
        "order_id",
        "product",
        "amount",
        "status",
        "type",
        "commission",
        "tds",
        "charge",
        "created_at",
      ],
      "Admin": [
        "ID",
        "BC Name",
        "Product",
        "Amount",
        "Commission",
        "TDS",
        "Charge",
        "Closing balance",
        "Opening Balance BC",
        "BC Commission",
        "BC TDS",
        "BC Charge",
        "Closing Balance BC",
        "Wallet Txn",
        "TXN Flow",
        "created_at",
      ],
     "Main Admin": [
  "id",
  "modified_at",
  "BC_ID",
  "BC Name",
  "Transection Type",
  "Product",

  "Opening Balance MAdmin",
  "Amount",
  "Commission",
  "Charge",
  "TDS",
  "Closing balance MAdmin",

  "Opening Balance Admin",
  "ACommission",
  "ATDS",
  "ACharge",
  "AGST",
  "Closing Balance Admin",

  "Opening Balance BC",
  "BC Commission",
  "BC TDS",
  "BC Charge",
  "Closing Balance BC",

  "Customer No",
  "Status",
  "Wallet Txn",
  "TXN Flow",
  "REF No",
  "ACK NO",
  "bank_rrn",
  "aadhar_number",
  "created_at",
  "TXN Date",
  "TXN Time",
  "TXN ID",
  "Admin"
]

    };

    const allowed = roleColumnMap[userRole] || [];
    baseConfig.columns = walletReportsConfig.columns.filter((col) =>
      allowed.includes(col.key)
    );

    return baseConfig;
  }, [userRole]);

  // === Table action handlers ===
  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEdit = (report) => {
    console.log("Editing report:", report);
  };

  const handleDelete = (report) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      console.log("Deleting report:", report);
    }
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };

  return (
    <PageWrapper config={walletReportsConfig} onDateFilter={handleDateFilter}>
     {!userid ? (
      <div>Loading...</div>
    ) : (
      <DataTable
        config={filteredConfig}
        tableData={tableData}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onExport={handleExport}
        onDeleteSelected={handleDeleteSelected}
      />
    )}
    </PageWrapper>
  );
};

export default OtherUserMainWalletReportsPage;
